<template>
  <div v-if="$route.name !== 'details' && !mobile" id="sidebar" class="sidebar_info" style="width: 365px; display:flex; flex-direction: column;">
    <router-view class="desktop-sidebar" name='routing'></router-view>
    <router-view class="desktop-search" name='races'></router-view>
    <router-view class="desktop-search" name='search'></router-view>
    <router-view class="desktop-cat" name='categories'></router-view>
    <router-view class="desktop-following" style="display: flex; flex: 1; overflow-x: scroll;" name="leaderboard"></router-view>
    <router-view class="desktop-following" name="checkpoint"></router-view>
    <router-view :key="$route.fullPath" class="desktop-athlete" name="athletedetailed"></router-view>
    <router-view class="desktop-following" name="following"></router-view>
    <router-view class="desktop-sportraxs" name='sportraxs'></router-view>
    <router-view v-if="event.id !== '220'" class="desktop-social" name='social'></router-view>
    <!--<div style="flex: 1;"></div>-->
  </div>
  <div v-else-if="!mobile" style="width: 1000px;" id="sidebar" class="sidebar_info">
    <router-view class="desktop-sidebar" name='routing'></router-view>
    <router-view class="desktop-search" name='search'></router-view>
    <router-view class="desktop-cat" name='categories'></router-view>
    <router-view class="desktop-details" name='details'></router-view>
    <router-view class="desktop-sportraxs" name='sportraxs'></router-view>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'
export default{
  computed: {
    ...mapGetters({
      mobile: 'mobile',
      event: 'event'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar.vue